module.exports = __webpack_public_path__ + "img/luke-job-pic.923c50d1.png";